<div class="ion-page modal-body" style="width: 100%;margin: 0px !important;padding: 0px !important;overflow: auto;">
  <div class="modalInnerWrapper modal-content" style="margin-top: 100px;">
    <div class="modal-body">
      <h4 class="t-h4 t-medium" style="margin-top: 5px !important;">Bet Slip Results</h4>





      <div *ngFor="let item of results " class="race-preview shadow p-0 mb-2">

        <div style="display: flex; justify-content: center;" *ngIf="item.countryCode == 'KR6' || item.countryCode == 'KR7'">
          <button class="price-table-btn" (click)="openPriceTable()">
            View Price Table
          </button>
        </div>

        <div *ngIf="(item.countryCode == 'KR6' || item.countryCode == 'KR7') && showPriceTable" class="price-table-overlay">
          <div class="price-table-modal">
            
            <button class="close-btn" (click)="closePriceTable()">✕</button>
        
            <app-image-zoom-viewer
                src="assets/images/keno_Prize_Table.jpg"
                alt="Price Table"
                [maxZoom]="4"
                [zoomStep]="0.5"
                *ngIf="item.countryCode == 'KR6'"
            ></app-image-zoom-viewer>

            <app-image-zoom-viewer
              src="assets/images/lucky_loot_Prize_Table.jpg"
              alt="Price Table"
              [maxZoom]="4"
              [zoomStep]="0.5"
              *ngIf="item.countryCode == 'KR7'"
            ></app-image-zoom-viewer>
          </div>
        </div>

        <div class="race-header bg-fill-secondary text-white">
          <div class="race-info">
            <div class="race-name text-uppercase">{{item.eventCode}} {{item.meetingName}}</div>
            <div class="race-description text-uppercase">Game: {{item.eventName}}</div>
          </div>
          <div class="race-extra" style="font-size: 0.7rem;font-weight: normal;">OFF TIME:
            {{item.offTimeLocal}}
            <span class="secondary">{{item.offTime}}</span>
          </div>
        </div>


        <div *ngIf="!item.isKLH && item.countryCode != 'KR6' && item.countryCode != 'KR7'" class="race-content" style="overflow: auto;">
          <table class="racing-table table-borderless table-striped">
            <thead>
              <tr>
                <th class="text-center">P</th>
                <th></th>
                <th class="text-left">Selection</th>
                <th>Win</th>
                <th>Place</th>
              </tr>
            </thead>
            <tbody>

              <tr class="won" *ngFor=" let positions of item.eventPositions; index as k">
                <td class="text-center">{{k+1}}</td>
                <td>{{positions.lastOddDisplay}}</td>
                <td class="text-left">{{positions.selectionName}}({{positions.selectionNumber}})</td>
                <td><span *ngIf="k==0">{{positions.winAmount}}</span></td>
                <td>{{positions.placeAmount}}</td>
              </tr>

            </tbody>
          </table>
        </div>

        <div *ngIf="item.countryCode == 'KR8'" class="result-box-KR8">
          <div class="result-row">
            <span class="label"></span>
            <span style="width: 30%;color: #555555c2;;">PAYS</span>
            <span style="width: 30%;color: #555555c2;;">RESULT</span>
          </div>

          <div class="result-row">
            <span class="label">Column</span>
            <span class="value">{{item.krrPrices.winnerColumn}}</span>
            <span class="value">{{item.krrWinnerColumn || '-'}}</span>
          </div>

          <div class="result-row">
            <span class="label">Row</span>
            <span class="value">{{item.krrPrices.winnerRow}}</span>
            <span class="value">{{item.krrWinnerRow || '-'}}</span>
          </div>

          <div class="result-row">
            <span class="label">Low / High</span>
            <span class="value">{{item.krrPrices.winnerLowHigh}}</span>
            <span class="value">{{item.krrWinnerLowHigh || '-'}}</span>
          </div>

          <div class="result-row">
            <span class="label">Odd / Even</span>
            <span class="value">{{item.krrPrices.winnerOddEven}}</span>
            <span class="value">{{item.krrWinnerOddEven || '-'}}</span>
          </div>

          <div class="result-row">
            <span class="label">Red / Black</span>
            <span class="value">{{item.krrPrices.winnerRedBlack}}</span>
            <span class="value">{{item.krrWinnerRedBlack || '-'}}</span>
          </div>
        </div>

        <div style="gap: 2px;" *ngIf="item.countryCode == 'KR6'" class="race-content">
          <div *ngFor="let position of item?.eventPositions">
            <span 
              [ngClass]="{'keno-yellow-button': checkBallColor(position) == 'yellow', 'keno-red-button': checkBallColor(position) == 'red'}" 
              class="numberCircleKeno" 
              style="display: inline-block;"
            >
              {{position.selectionNumber}}
            </span>
          </div>

          <div class="result-box-kr6">
            <div class="result-row">
              <span class="label">Heads/Evens/Tails</span>
              <span class="value">{{item?.kknWinnerHeadsEvensTails}}</span>
            </div>
          </div>
        </div>

        <div *ngIf="item.countryCode == 'KR7'" class="race-content">
          <div class="race-content klh" style="width: 100%;" >
            <table class="racing-table table-borderless table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th class="text-left">RESULT</th>
                </tr>
              </thead>
              <tbody>
    
                <tr>
                  <td>FIRST 6</td>
                  <td>
                    <div class="icon-box-ll">
                      <div *ngFor="let position of item?.eventPositions" class="dib">
                        <span 
                        [ngClass]="{'bonus-ball': checkBonusBall(position,item?.kllBonusBall),'red-button': checkBallColorLL(position) == 'red', 'blue-button' : checkBallColorLL(position) == 'blue' , 'green-button': checkBallColorLL(position) == 'green', 'yellow-button' : checkBallColorLL(position) == 'yellow'}"
                        class="numberCircleLL">{{position.selectionNumber}}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr >
                  <td>FIRST 5</td>
                  <td>
                    <div class="icon-box-ll">
                      <div *ngFor="let position of item?.eventPositions | slice:0:5" class="dib">
                        <span 
                        [ngClass]="{'bonus-ball': checkBonusBall(position,item?.kllBonusBall),'red-button': checkBallColorLL(position) == 'red', 'blue-button' : checkBallColorLL(position) == 'blue' , 'green-button': checkBallColorLL(position) == 'green', 'yellow-button' : checkBallColorLL(position) == 'yellow'}"
                        class="numberCircleLL">{{position.selectionNumber}}</span>
                      </div>                    
                    </div>
                  </td>
                </tr>
                <tr >
                  <td>FIRST 4</td>
                  <td>
                    <div class="icon-box-ll">
                      <div *ngFor="let position of item?.eventPositions | slice:0:4" class="dib">
                        <span 
                        [ngClass]="{'bonus-ball': checkBonusBall(position,item?.kllBonusBall),'red-button': checkBallColorLL(position) == 'red', 'blue-button' : checkBallColorLL(position) == 'blue' , 'green-button': checkBallColorLL(position) == 'green', 'yellow-button' : checkBallColorLL(position) == 'yellow'}"
                        class="numberCircleLL">{{position.selectionNumber}}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr  >
                  <td>FIRST 3</td>
                  <td>
                    <div class="icon-box-ll">
                      <div *ngFor="let position of item?.eventPositions | slice:0:3" class="dib">
                        <span 
                        [ngClass]="{'bonus-ball': checkBonusBall(position,item?.kllBonusBall),'red-button': checkBallColorLL(position) == 'red', 'blue-button' : checkBallColorLL(position) == 'blue' , 'green-button': checkBallColorLL(position) == 'green', 'yellow-button' : checkBallColorLL(position) == 'yellow'}"
                        class="numberCircleLL">{{position.selectionNumber}}</span>
                      </div> 
                    </div>
                  </td>
                </tr>
                <tr >
                  <td>FIRST 2</td>
                  <td>
                    <div class="icon-box-ll">
                      <div *ngFor="let position of item?.eventPositions | slice:0:2" class="dib">
                        <span 
                        [ngClass]="{'bonus-ball': checkBonusBall(position,item?.kllBonusBall),'red-button': checkBallColorLL(position) == 'red', 'blue-button' : checkBallColorLL(position) == 'blue' , 'green-button': checkBallColorLL(position) == 'green', 'yellow-button' : checkBallColorLL(position) == 'yellow'}"
                        class="numberCircleLL">{{position.selectionNumber}}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr  >
                  <td>FIRST BALL</td>
                  <td>
                    <div class="icon-box-ll">
                      <div *ngFor="let position of item?.eventPositions | slice:0:1" class="dib">
                        <span 
                        [ngClass]="{'bonus-ball': checkBonusBall(position,item?.kllBonusBall),'red-button': checkBallColorLL(position) == 'red', 'blue-button' : checkBallColorLL(position) == 'blue' , 'green-button': checkBallColorLL(position) == 'green', 'yellow-button' : checkBallColorLL(position) == 'yellow'}"
                        class="numberCircleLL">{{position.selectionNumber}}</span>
                      </div>                     
                    </div>
                  </td>
                </tr>
                <tr  >
                  <td>FIRST COLOR</td>
                  <td>
                    <div class="icon-box-ll">
                      <div *ngFor="let position of item?.eventPositions | slice:0:1" class="dib">
                        <span 
                        [ngClass]="{'red-button': checkBallColorLL(position) == 'red', 'blue-button' : checkBallColorLL(position) == 'blue' , 'green-button': checkBallColorLL(position) == 'green', 'yellow-button' : checkBallColorLL(position) == 'yellow'}"
                        class="numberCircleLL"></span>
                      </div>                     
                    </div>
                  </td>
                </tr>
                <tr  >
                  <td>SOD ODD/EVEN</td>
                  <td class="text-left">{{item?.kllWinnerSodOddEven}}</td>
                </tr>
                <tr  >
                  <td>SOD OVER/UNDER</td>
                  <td class="text-left">{{item?.kllWinnerSodOverUnder}}</td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="!item.isKLH && item.countryCode != 'KR6' && item.countryCode != 'KR7'" class="race-footer">
          <div class="d-flex">
            <div *ngIf="item.csfLabel" class="d-flex flex-fill flex-column text-left">
              <span class="t-faded t-small">{{item.csfLabel}}:</span>
              <span class="t">{{item.csf}}</span>
            </div>
            <div *ngIf="item.tcLabel" class="d-flex flex-fill flex-column">
              <span class="t-faded t-small">{{item.tcLabel}}:</span>
              <span class="t">{{item.tc}}</span>
            </div>
            <div *ngIf="item.qnLabel" class="d-flex flex-fill flex-column text-right">
              <span class="t-faded t-small">{{item.qnLabel}}:</span>
              <span class="t">{{item.qn}}</span>
            </div>
          </div>

          <div class="d-flex">
            <div *ngIf="item.favNews" class="d-flex flex-fill flex-column" style="text-align: left;">
              <span class="t-faded t-small">Favourite:</span>
              <span class="t">{{item.favNews}}</span>
            </div>
            <div class="d-flex flex-fill flex-column" style="text-align: left;">
              <span class="t-faded t-small">Ran:</span>
              <span *ngIf="item.runners" class="t">{{item.runners}}</span>
            </div>
            <div class="d-flex flex-fill flex-column" style="text-align: left;">
              <span class="t-faded t-small">N/R:</span>
              <span *ngIf="item.nrStr" class="t">{{item.nrStr}}</span>
            </div>

          </div>
          <div class="d-flex">

            <div class="d-flex flex-fill flex-column" style="text-align: left;">
              <span class="t-faded t-small">Rule 4:</span>
              <span *ngIf="item.rule4TypeADeduct >= 1" class="t">{{item.rule4TypeADeduct}}P</span>
            </div>

          </div>
        </div>

        <div *ngIf="item.isKLH" class="race-content klh">
          <table class="racing-table table-borderless table-striped">
            <thead>
              <tr>
                <th></th>
                <th class="text-left">PAYS</th>
                <th></th>
                <th class="text-left">RESULT</th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td>FIRST 6</td>
                <td class="text-left">LKR {{item?.klhPrices?.first6}}
                  <br> or
                  <br> LKR {{item?.klhPrices?.first65or4}}
                  <p class="winner-text-s">For 5 or 4</p>
                </td>
                <td></td>
                <td>
                  <div class="icon-box">
                    <div *ngFor="let position of item?.eventPositions" class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                        'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                        'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                        'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                        }" class="numberCircle">{{position.selectionNumber}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>FIRST 5</td>
                <td class="text-left">LKR {{item?.klhPrices?.first5}}
                  <br> or
                  <br> LKR {{item?.klhPrices?.first54or3}}
                  <p class="winner-text-s">For 4 or 3</p>
                </td>
                <td></td>
                <td>
                  <div class="icon-box">
                    <div *ngFor="let position of item?.eventPositions | slice:0:5" class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                        'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                        'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                        'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                        }" class="numberCircle">{{position.selectionNumber}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>FIRST 4</td>
                <td class="text-left">LKR {{item?.klhPrices?.first4}}
                  <br> or
                  <br> LKR {{item?.klhPrices?.first43or2}}
                  <p class="winner-text-s">For 3 or 2</p>
                </td>
                <td></td>
                <td>
                  <div class="icon-box">
                    <div *ngFor="let position of item?.eventPositions | slice:0:4" class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                        'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                        'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                        'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                        }" class="numberCircle">{{position.selectionNumber}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>FIRST 3</td>
                <td class="text-left">LKR {{item?.klhPrices?.first3}}
                  <br> or
                  <br> LKR {{item?.klhPrices?.first32}}
                  <p class="winner-text-s">For 2</p>
                </td>
                <td></td>
                <td>
                  <div class="icon-box">
                    <div *ngFor="let position of item?.eventPositions | slice:0:3" class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                        'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                        'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                        'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                        }" class="numberCircle">{{position.selectionNumber}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>FIRST 2</td>
                <td class="text-left">LKR {{item?.klhPrices?.first2}}
                  <br> or
                  <br> LKR {{item?.klhPrices?.first21}}
                  <p class="winner-text-s">For 1</p>
                </td>
                <td></td>
                <td>
                  <div class="icon-box">
                    <div *ngFor="let position of item?.eventPositions | slice:0:2" class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                        'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                        'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                        'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                        }" class="numberCircle">{{position.selectionNumber}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>WINNER</td>
                <td class="text-left">LKR {{item?.klhPrices?.winnerNumber}}
                  <p class="winner-text-s">Number</p>
                </td>
                <td class="text-left">LKR {{item?.klhPrices?.winnerColor}}
                  <p class="winner-text-s">Color</p>
                </td>
                <td>
                  <div class="icon-box">
                    <div *ngFor="let position of item?.eventPositions | slice:0:1" class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                        'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                        'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                        'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                        }" class="numberCircle">{{position.selectionNumber}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>1 IN FIRST 2</td>
                <td class="text-left">LKR {{item?.klhPrices?.oneInFirst2Number}}</td>
                <td></td>
                <td>
                  <div *ngIf="item.eventPositions?.length>0" class="icon-box">

                    <div class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(item?.eventPositions[0]) == 'red', 'blue-button' : checkKr3Color(item?.eventPositions[0]) == 'blue' ,
                        'green-button': checkKr3Color(item?.eventPositions[0]) == 'green', 'yellow-button' : checkKr3Color(item?.eventPositions[0]) == 'yellow' ,
                        'black-button': checkKr3Color(item?.eventPositions[0]) == 'black', 'purple-button' : checkKr3Color(item?.eventPositions[0]) == 'purple' ,
                        'orange-button': checkKr3Color(item?.eventPositions[0]) == 'orange', 'white-button' : checkKr3Color(item?.eventPositions[0]) == 'white'
                        }" class="numberCircle">{{item?.eventPositions[0].selectionNumber}}</span>
                    </div>

                    <p class="or-text">OR</p>

                    <div class="dib">
                      <span [ngClass]="{'red-button': checkKr3Color(item?.eventPositions[1]) == 'red', 'blue-button' : checkKr3Color(item?.eventPositions[1]) == 'blue' ,
                        'green-button': checkKr3Color(item?.eventPositions[1]) == 'green', 'yellow-button' : checkKr3Color(item?.eventPositions[1]) == 'yellow' ,
                        'black-button': checkKr3Color(item?.eventPositions[1]) == 'black', 'purple-button' : checkKr3Color(item?.eventPositions[1]) == 'purple' ,
                        'orange-button': checkKr3Color(item?.eventPositions[1]) == 'orange', 'white-button' : checkKr3Color(item?.eventPositions[1]) == 'white'
                        }" class="numberCircle">{{item?.eventPositions[1].selectionNumber}}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>LOW</td>
                <td class="text-left">LKR {{item?.klhPrices?.lowFirstNumber}}</td>
                <td></td>
                <td class="text-left">{{item?.klhWinnerLowHigh}}</td>
              </tr>
              <tr>
                <td>ODD/EVEN</td>
                <td class="text-left">LKR {{item?.klhPrices?.oddFirstNumber || item?.klhPrices?.evenFirstNumber}}</td>
                <td></td>
                <td class="text-left">{{item?.klhWinnerOddEven}}</td>
              </tr>

            </tbody>
          </table>
        </div>




      </div>



    </div>
    <button (click)="dismiss()" type="link" class="close">
      <span class="icon icon-close"></span>
    </button>
  </div>
</div>